import Vue from 'vue'
import { Chrome } from 'vue-color'

Vue.component('ColorPicker', Chrome);